import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { UploadFile } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import ControlledInputField from "../../../component/ui/FormFields/ControlledTextInputField";
import { convertCustomerToVendorRequest } from "../../../redux/Vendors/actions/vendorActions";

const ConvertCustomerToVendorModal = ({
  open,
  onClose,
  customerDetails,
  customerId,
  loading,
}) => {
  const dispatch = useDispatch();
  const [selectedFileName, setSelectedFileName] = React.useState("");
  console.log("customerDetails", customerDetails);
  const { handleSubmit, control, setValue, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      discount: 10,
      company_reg_number: "COMP123456789",
      proof_image: "",
    },
  });

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedFileTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/jpg",
        "application/pdf",
      ];
      if (!allowedFileTypes.includes(file.type)) {
        toast.error("Only image files and PDF files are allowed", {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSizeInBytes) {
        toast.error("File size should not exceed 5MB", {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64Data = reader.result.split(",")[1];
        setValue("proof_image", base64Data);
        setSelectedFileName(file.name);
      };
    }
  };

  const onSubmit = (data) => {
    if (!data.proof_image) {
      toast.error("Proof image is required", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }
    dispatch(
      convertCustomerToVendorRequest({
        customer_id: customerId,
        discount: data.discount,
        company_reg_number: data.company_reg_number,
        proof_image: data.proof_image,
        agency_name: "",
        pan_number: "",
        gstin_number: "",
        iata_reg_no: "",
        commission_rate: 0,
      }),
    );
  };

  React.useEffect(() => {
    if (!open) {
      reset();
      setSelectedFileName("");
    }
  }, [open, reset]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Convert Customer to Vendor
      </DialogTitle>
      <DialogContent dividers>
        <Box component="form" sx={{ mt: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ fontWeight: "bold" }}
              >
                Commission Discount (%)
              </Typography>
              <ControlledInputField
                name="discount"
                type="number"
                control={control}
                rules={{ required: "Discount is required", min: 0, max: 100 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ fontWeight: "bold" }}
              >
                Company Registration Number
              </Typography>
              <ControlledInputField
                name="company_reg_number"
                control={control}
                rules={{ required: "Company reg number is required" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ fontWeight: "bold" }}
              >
                Proof Image / Document
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                width="100%"
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <input
                  type="file"
                  onChange={handleFileUpload}
                  accept="image/jpeg,image/png,image/gif,image/jpg,application/pdf"
                  style={{ display: "none" }}
                  id="modal-upload-document"
                />
                <label htmlFor="modal-upload-document" style={{ flexGrow: 1 }}>
                  <Button
                    component="span"
                    variant="outlined"
                    startIcon={<UploadFile />}
                    sx={{
                      textTransform: "none",
                      width: "100%",
                      justifyContent: "flex-start",
                    }}
                  >
                    {selectedFileName
                      ? selectedFileName
                      : "Upload Proof Document *"}
                  </Button>
                </label>
                {selectedFileName && (
                  <IconButton
                    size="small"
                    onClick={() => {
                      setValue("proof_image", "");
                      setSelectedFileName("");
                    }}
                    sx={{
                      marginLeft: 1,
                      backgroundColor: "rgba(0,0,0,0.1)",
                      "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          className="success-button"
          disabled={loading}
        >
          {loading ? "Converting..." : "Convert"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConvertCustomerToVendorModal;
